import { InjectionToken } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { currentEmployerViewReducer } from '../components/current-employer/current-employer/reducer';
import { employerBalancesReducer } from '../components/employer-balances/reducer';
import { jetcoClaimAmountReducer } from '../components/jetco-claim-amount/reducer';

import { mainLayoutReducer } from '../layout/main/reducer'
import { employerHistoryViewReducer } from '../views/employment-history/reducer';
import { jetcoLodgeClaimReducer } from '../views/jetco/lodge-claim/reducer';
import { lodgeClaimReducer } from '../views/lodge-claim/reducer';
import { CIRTState } from './cirt.states';
import { greenIdReducer } from '../components/greenid/reducers';

export const featureKey = 'cirt';

export const reducers = new InjectionToken<ActionReducerMap<CIRTState>>(featureKey, {
  factory: () => ({
    mainLayout: mainLayoutReducer,
    currentEmployer: currentEmployerViewReducer,
    jetcoLodgeClaim: jetcoLodgeClaimReducer,
    employerHistoryViewState: employerHistoryViewReducer,
    jetcoClaimAmountState: jetcoClaimAmountReducer,
    employerBalancesState: employerBalancesReducer,
    lodgeClaim: lodgeClaimReducer,
    greenIdState: greenIdReducer
  })
});
